import { useEffect } from "react";
import { Loader2 } from "lucide-react";

/**
 * NativeCallback - Intermediate page for OAuth in native apps
 * 
 * This page runs inside ASWebAuthenticationSession (iOS) or Chrome Custom Tab (Android).
 * It receives OAuth tokens from Supabase and redirects back to the app via deeplink.
 * 
 * The "oauth/" prefix in the deeplink tells Despia to:
 * 1. Close the secure browser
 * 2. Navigate the WebView to /auth with the tokens as query params
 */
const NativeCallback = () => {
  useEffect(() => {
    // Get tokens from URL hash (Supabase sends them as hash fragments)
    const hash = window.location.hash.substring(1);
    const params = new URLSearchParams(hash);
    
    const accessToken = params.get('access_token');
    const refreshToken = params.get('refresh_token');
    const error = params.get('error');
    const errorDescription = params.get('error_description');

    console.log('[NativeCallback] Processing OAuth callback');
    console.log('[NativeCallback] Has access_token:', !!accessToken);
    console.log('[NativeCallback] Has refresh_token:', !!refreshToken);
    console.log('[NativeCallback] Error:', error);

    // Build the deeplink URL
    // The "oauth/" prefix is crucial - it tells Despia to close the browser
    const deeplinkScheme = 'easyfinder';
    
    if (error) {
      // Redirect with error
      const errorUrl = `${deeplinkScheme}://oauth/auth?error=${encodeURIComponent(error)}&error_description=${encodeURIComponent(errorDescription || '')}`;
      console.log('[NativeCallback] Redirecting with error:', errorUrl);
      window.location.href = errorUrl;
      return;
    }

    if (accessToken && refreshToken) {
      // Redirect with tokens
      const successUrl = `${deeplinkScheme}://oauth/auth?access_token=${encodeURIComponent(accessToken)}&refresh_token=${encodeURIComponent(refreshToken)}`;
      console.log('[NativeCallback] Redirecting with tokens');
      window.location.href = successUrl;
      return;
    }

    // No tokens and no error - something went wrong
    console.error('[NativeCallback] No tokens or error found in URL');
    const fallbackUrl = `${deeplinkScheme}://oauth/auth?error=no_tokens&error_description=${encodeURIComponent('Aucun token reçu de l\'authentification')}`;
    window.location.href = fallbackUrl;
  }, []);

  return (
    <div className="min-h-screen bg-background flex items-center justify-center">
      <div className="flex flex-col items-center gap-4 text-center px-4">
        <Loader2 className="w-8 h-8 animate-spin text-primary" />
        <div>
          <h1 className="text-lg font-semibold">Connexion en cours...</h1>
          <p className="text-sm text-muted-foreground mt-1">
            Redirection vers l'application
          </p>
        </div>
      </div>
    </div>
  );
};

export default NativeCallback;
